import { render, staticRenderFns } from "./InputErrorIcon.vue?vue&type=template&id=b6d003c0&"
import script from "./InputErrorIcon.vue?vue&type=script&lang=ts&"
export * from "./InputErrorIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports